import React from 'react';
import PropTypes from 'prop-types';
import config from '../../config';
import { normalizeResourceAllocations } from 'helpers/resourceAllocations';

export default function ResourceAllocationIndicator({ appointment = {} }) {
  const services = [appointment,
    ...(Array.isArray(appointment.addonservices) ? appointment.addonservices : []),
    ...(Array.isArray(appointment.addanotherservices) ? appointment.addanotherservices : []),
  ];
  const allocated = services.some(service => normalizeResourceAllocations(service)
    .some(allocation => allocation.resource_item_id));
  return allocated ? (
    <img src={`${config.imagepath}resource_logo2.png`}
      className="calendar-resource-brand-logo" alt="Resources allocated" />
  ) : null;
}

ResourceAllocationIndicator.propTypes = { appointment: PropTypes.object };
